import { render, staticRenderFns } from "./PointProductEdit.vue?vue&type=template&id=45b7aa26&scoped=true"
import script from "./PointProductEdit.vue?vue&type=script&lang=js"
export * from "./PointProductEdit.vue?vue&type=script&lang=js"
import style0 from "./PointProductEdit.vue?vue&type=style&index=0&id=45b7aa26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7aa26",
  null
  
)

export default component.exports